export default __webpack_public_path__ + "static/media/ic-art-personal-care.76f8ca74.svg";